import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const audiences = ['Small business owners', 'Solopreneurs', 'Consultants', 'Tax and bookkeeping professionals', 'Real estate professionals', 'Beauty and wellness professionals', 'Creative service providers', 'Nonprofits and community organizations', 'Event planners and rental businesses', 'Local service companies', 'Online brands and e-commerce sellers'];
export function WhoItIsFor() {
  return <section className="py-24 bg-slate-900 text-white overflow-hidden relative" data-id="element-208">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-blue-600/10 blur-3xl rounded-full translate-x-1/2" data-id="element-209"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-210">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-211">
          <div data-id="element-212">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" data-id="element-213">
              Designed for Professionals, Startups, and Growing SMBs
            </h2>
            <p className="text-slate-400 text-lg mb-8 leading-relaxed" data-id="element-214">
              BizCloudDesk is being built for business owners who need a
              practical, organized, and affordable way to manage their online
              presence and digital tools without having to piece everything
              together alone.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-215">
              {audiences.map(item => <div key={item} className="flex items-center gap-3 text-slate-300" data-id="element-216">
                  <CheckCircle2Icon className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-217" />
                  <span className="text-sm font-medium" data-id="element-218">{item}</span>
                </div>)}
            </div>
          </div>
          <div className="bg-slate-800 p-8 rounded-3xl border border-slate-700 shadow-2xl" data-id="element-219">
            <div className="space-y-6" data-id="element-220">
              <div className="flex gap-4" data-id="element-221">
                <div className="w-12 h-12 bg-blue-600/20 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-222">
                  <span className="text-blue-400 font-bold" data-id="element-223">01</span>
                </div>
                <div data-id="element-224">
                  <h4 className="font-bold text-lg mb-1" data-id="element-225">
                    Centralized Operations
                  </h4>
                  <p className="text-slate-400 text-sm" data-id="element-226">
                    All your essential tools in one professional dashboard.
                  </p>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-227">
                <div className="w-12 h-12 bg-blue-600/20 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-228">
                  <span className="text-blue-400 font-bold" data-id="element-229">02</span>
                </div>
                <div data-id="element-230">
                  <h4 className="font-bold text-lg mb-1" data-id="element-231">Scalable Growth</h4>
                  <p className="text-slate-400 text-sm" data-id="element-232">
                    Start small and add services as your business expands.
                  </p>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-233">
                <div className="w-12 h-12 bg-blue-600/20 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-234">
                  <span className="text-blue-400 font-bold" data-id="element-235">03</span>
                </div>
                <div data-id="element-236">
                  <h4 className="font-bold text-lg mb-1" data-id="element-237">Professional Image</h4>
                  <p className="text-slate-400 text-sm" data-id="element-238">
                    Enterprise-grade tools tailored for the small business
                    budget.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}